import { Card, CardContent, Typography } from '@mui/material';
import type { AdminEligibilityListResponse } from '@store/generated/admin';

interface EligibilityWorkqueueStatsProps {
  data?: AdminEligibilityListResponse;
  loading?: boolean;
}

export function EligibilityWorkqueueStats({ data, loading }: EligibilityWorkqueueStatsProps) {
  const summary = data?.summary;
  const totalQueue = (summary?.blocked_count ?? 0) + (summary?.needs_review_count ?? 0);

  const cards = [
    {
      label: 'Total Queue',
      value: totalQueue,
      color: 'text-blue-700',
      bg: 'bg-blue-50',
      border: 'border-blue-200',
    },
    {
      label: 'Blocked',
      value: summary?.blocked_count ?? 0,
      color: 'text-red-700',
      bg: 'bg-red-50',
      border: 'border-red-200',
    },
    {
      label: 'Expiring Soon',
      value: summary?.expiring_soon_count ?? 0,
      color: 'text-orange-700',
      bg: 'bg-orange-50',
      border: 'border-orange-200',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {cards.map(card => (
        <Card key={card.label} variant="outlined" className={`${card.bg} ${card.border}`}>
          <CardContent className="py-4">
            <Typography variant="body2" className="text-gray-600 mb-1">
              {card.label}
            </Typography>
            <Typography variant="h4" className={`font-bold ${card.color}`}>
              {loading ? '...' : card.value}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
